export enum PushActionsTypes {
  SET_PUSH_MESSAGES = 'push/SET_PUSH_MESSAGES',
  READ_PUSH_MESSAGE_REQUEST = 'push/READ_PUSH_MESSAGE_REQUEST',
  READ_PUSH_MESSAGE_SUCCESS = 'push/READ_PUSH_MESSAGE_SUCCESS',
  HIDE_PUSH_MESSAGE_REQUEST = 'push/HIDE_PUSH_MESSAGE_REQUEST',
  HIDE_PUSH_MESSAGE_SUCCESS = 'push/HIDE_PUSH_MESSAGE_SUCCESS',
}
